import { ArrowLeft, ArrowRight, Button, Delete, Heading } from '@core/ui';
import { t } from 'i18next';
import { Duration } from 'luxon';
import { useEffect, useState } from 'react';
import { PollTimelineEvent, Timeline } from '../../../parser';

export const PollEditorOrganism = ({
    timeline,
    currentTime,
    onSeek,
    onDelete
}: {
    timeline: Timeline;
    currentTime: Duration;
    onSeek: (seek: Duration) => void;
    onDelete: (poll: PollTimelineEvent) => void;
}) => {
    const [previousPoll, setPreviousPoll] = useState<PollTimelineEvent>();
    const [currentPoll, setCurrentPoll] = useState<PollTimelineEvent>();
    const [nextPoll, setNextPoll] = useState<PollTimelineEvent>();

    useEffect(() => {
        let previous: PollTimelineEvent | undefined;
        let current: PollTimelineEvent | undefined;
        let next: PollTimelineEvent | undefined;

        for (let i = 0; i < timeline.polls.length; i++) {
            if (timeline.polls[i].timestamp <= currentTime) {
                previous = i > 0 ? timeline.polls[i - 1] : undefined;
                current = timeline.polls[i];
                next = i < timeline.polls.length - 1 ? timeline.polls[i + 1] : undefined;
            }
        }

        if (!current && timeline.polls.length > 0) {
            next = timeline.polls[0];
        }

        setPreviousPoll(previous);
        setCurrentPoll(current);
        setNextPoll(next);
    }, [timeline.polls, currentTime]);

    return (
        <div className="bg-gray-100 border border-gray-500 flex flex-col gap-4 pb-2">
            <div className="flex-1 flex flex-col bg-white rounded-b-webinarsub p-4">
                <div className="flex items-center justify-between gap-2 mb-4">
                    <Heading variant="h2">{t('Editor.Poll.Heading')}</Heading>
                    {currentPoll && (
                        <Button variant="warning-outline" onClick={() => onDelete(currentPoll)} iconbtn classNames="ms-auto">
                            <Delete classNames="size-6 flex-none stroke-current" />
                            <span className="sr-only">{t('Editor.Poll.Button.Delete')}</span>
                        </Button>
                    )}
                </div>
                <div className="flex-1 flex items-center justify-center gap-x-2">
                    <Button variant="primary" iconbtn onClick={() => onSeek(previousPoll?.timestamp || Duration.fromMillis(0))} disabled={!previousPoll}>
                        <span className="sr-only">{t('Editor.Poll.Button.Previous')}</span>
                        <ArrowLeft classNames="size-6 fill-current" />
                    </Button>
                    <p className="flex-1 text-center">{currentPoll?.poll.question}</p>
                    <Button variant="primary" iconbtn onClick={() => onSeek(nextPoll?.timestamp || Duration.fromMillis(0))} disabled={!nextPoll}>
                        <span className="sr-only">{t('Editor.Poll.Button.Next')}</span>
                        <ArrowRight classNames="size-6 fill-current" />
                    </Button>
                </div>
            </div>
        </div>
    );
};
